import * as types from './mutation-types'

export default {
  [types.UPDATE_APP_LOADING_STATUS]: (state, data) => {
    state.isAppLoaded = data
  },
  [types.UPDATE_APP_MODULE_LOADING_STATUS]: (state, data) => {
    state.isAppModuleLoaded = data
  },
  [types.SET_APP_ASIDE_MINIMIZE_STATE]: (state) => {
    state.appAsideMinimize = !state.appAsideMinimize
  }
}
